import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { ChevronDownIcon, PhoneIcon, PlayCircleIcon } from '@heroicons/react/20/solid'
import {
  ArrowPathIcon,
  ChartPieIcon,
  CursorArrowRaysIcon,
  FingerPrintIcon,
  SquaresPlusIcon,
  BanknotesIcon,
  DocumentTextIcon,
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline'

const solutions = [
    { name: 'Opciones', description: 'Seleccione la opción correcta por favor', href: '#', icon: InformationCircleIcon },
    /*
  { name: 'Engagement', description: 'Speak directly to your customers', href: '#', icon: CursorArrowRaysIcon },
  { name: 'Security', description: "Your customers' data will be safe and secure", href: '#', icon: FingerPrintIcon },
  { name: 'Integrations', description: 'Connect with third-party tools', href: '#', icon: SquaresPlusIcon },
  { name: 'Automations', description: 'Build strategic funnels that will convert', href: '#', icon: ArrowPathIcon },*/
]
const callsToAction = [
  { name: 'Colegiatura, Nivelación', href: '#', icon: BanknotesIcon},
  { name: 'Registrar boleta', href: '#', icon: DocumentTextIcon},
  { name: 'Cancelar', href: '#', icon: XMarkIcon},
]

const LayoutMenu = ({ setEstado }) => {
  return (
    <Popover className="relative">
      <Transition
        show={true}
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2  px-4 m-auto">
          <div className="w-screen max-w-2xl  flex-auto overflow-hidden rounded-xl bg-secundarioMira text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
            <div className="p-4">
              {solutions.map((item) => (
                <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-4 |hover:bg-gray-50">
                  <div className="mt-1 flex h-12 w-12 flex-none items-center justify-center rounded-lg bg-secundarioMira |group-hover:bg-white">
                    <item.icon className="h-12 w-12 text-secundario " aria-hidden="true" />
                  </div>
                  <div>
                    <a href={item.href} className="font-semibold text-white">
                      {item.name}
                      <span className="absolute inset-0" />
                    </a>
                    <p className="mt-1 text-gray-100">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-3 divide-x divide-gray-900/5">
              {callsToAction.map((item, index) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={()=> setEstado(index)}
                  className={`flex items-center justify-center gap-x-2.5 p-3 font-semibold text-white bg-${index === 2 ? "secundario":"azulBrillanteMira"} hover:bg-secundario`}
                >
                  <item.icon className="h-5 w-5 flex-none text-white" aria-hidden="true" />
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  )
}

export default LayoutMenu